import { render, staticRenderFns } from "./form-objectives.vue?vue&type=template&id=cbc7194a&scoped=true"
import script from "./form-objectives.vue?vue&type=script&lang=js"
export * from "./form-objectives.vue?vue&type=script&lang=js"
import style0 from "./form-objectives.vue?vue&type=style&index=0&id=cbc7194a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbc7194a",
  null
  
)

export default component.exports